module.exports = __webpack_public_path__ + "static/media/praca-na-zadanie-off.57bc7d72.svg";